import fetch from './handler'

export const login = (body) => {
    return fetch({
        method: 'POST',
        url: '/user/login',
        body,
        jsonData: true
    })
}